<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="idx"
      :headers="headers"
      :items="datiMostrati"
      :options.sync="options"
      :server-items-length="totaleDati"
      :loading="loading"
      :disable-pagination="true"
      :hide-default-footer="true"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Carica le conte inventariali per inventario prodotti</v-toolbar-title>
        <v-subheader>Puoi completarle con le informazioni dei prodotti ed esportarne il riepilogo</v-subheader>
      </v-toolbar>
      <parametri
        :loading="isimportaLetture"
        :pulisci="triggerPulisci"
        @importa="importaLetture"
        @importaArray="importaLettureArray"
        @onLoaded="onLoaded"
        @importMovimenti="onImportaMovimenti"
        />
    </template>
    <template v-slot:no-data>
      Carica un file di inventario
    </template>
    </v-data-table>
    <letture :reload="triggerReload"/>
    <!-- <speed-dial @comando="onSpeedDialogComando"/> -->
    <v-dialog
      v-model="isimportaLetture"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Importazione letture in corso
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Parametri from './parametri'
  import Letture from './letture'
  import magazzino from '@/services/magazzinoService'
  import movimenti from '@/services/movimentiService'
  import configurazioni from '@/services/configurazioniService'

  export default {
    components: {
      Parametri,
      Letture    
    },
    data () {
      return {
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        mostaRaw: false,
        datiRaw: [],
        datiModello: [],
        totaleDati: 0,
        intestazioniRaw: [],
        intestazioniModello: [],
        isimportaLetture: false,
        modelloItem: null,
        triggerReload: 0,
        triggerPulisci: 0
      }
    },
    async mounted() {
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova riga' : 'Modifica riga'
      },
      datiMostrati() {
        let dati = this.datiRaw
        dati = dati.map((x, idx) => { return { idx, ...x } })
        return dati
      },
      headers() {
        return this.creaHeaders(this.intestazioniRaw)
      }
    },
    watch: {
      options: {
        async handler () {
          this.loading = false
        },
        deep: true
      }
    },
    methods: {
      async onImportaMovimenti(searchDate) {
        let causali = await configurazioni.getConfigurazione("magazzino_causali", "causali");
        causali = causali.filter(x => x.tipo === 'rettifica')
        const causaliRettifica = causali.map(x => x.codice)   
        this.loadingSearch = true
        const filtri = {
          causale: causaliRettifica,
          start: searchDate.start,
          end: searchDate.end
        }
        const opzioni = {
          page: 1,
          itemsPerPage: 100000
        }
        // const elenco = await movimenti.getFilteredMovementHeaders(filtri, opzioni)
        const elenco = await movimenti.getFilteredMovementInventarioHeaders(filtri, opzioni)
        
        const mm = elenco.rows
        console.log(mm.length)
        for (let m of mm) {
          this.datiRaw.push({
            _id: m.prodotto.codice,
            quantita: m.quantita
          })
        }
        this.totaleDati = this.datiRaw.length
        this.intestazioniRaw = [
          { value: 'Id', key: '_id' },
          { value: 'Quantità', key: 'quantita' }
        ]
/*         this.datiRaw = dati.datiRaw
        this.totaleDati = dati.datiRaw.length
        this.intestazioniRaw = dati.intestazioniRaw */
        // { text: c.value, value: c.key }
      },
      backClick() {
        this.$emit('back')
      },
      onLoaded(dati) {
        if (!dati) {
          this.datiRaw = []
          this.totaleDati = 0
          this.intestazioniRaw = []
          return
        }
        this.datiRaw = dati.datiRaw
        this.totaleDati = dati.datiRaw.length
        this.intestazioniRaw = dati.intestazioniRaw
      },
      creaHeaders(colonne, dati) {
        const hd = []
        for (let c of colonne) {
          const hh = { text: c.value, value: c.key }
          hd.push(hh)
        }
        return hd
      },
      async importaLetture(infoImport) {
         if (this.totaleDati > 0) {
          this.isimportaLetture = true
          const datiRaw = this.selected.length > 0 ? this.selected : this.datiRaw
          var datiReduce
          if (infoImport.tipoFile === 'Excel') {
            datiReduce = _.reduce(datiRaw, function(result, value, key, collection) {
              let chiave = String(value.barcode).trim()
              let prec = result[chiave] || { barcode: chiave, quantita: 0 }
              prec.quantita += parseInt(value.quantita)
              result[chiave] = prec
              return result
            }, {})
          } else if (infoImport.tipoFile === 'Excel-C') {
            datiReduce = _.reduce(datiRaw, function(result, value, key, collection) {
              let chiave = String(value.codice).trim()
              let prec = result[chiave] || { codice: chiave, quantita: 0 }
              prec.quantita += parseInt(value.quantita)
              result[chiave] = prec
              return result
            }, {})            
          } else if (infoImport.tipoFile === 'Excel-T-C') {
            datiReduce = _.reduce(datiRaw, function(result, value, key, collection) {
              // per reduce, non importa se ci sono caratteri non validi nei dati
              let chiave = String(value.codice).trim().concat(String(value.taglia || '').trim()).concat(String(value.colore || '').trim())
              let prec = result[chiave] || {
                  codice: String(value.codice).trim(),
                  taglia: String(value.taglia || '').trim(),
                  colore: String(value.colore || '').trim(),
                  quantita: 0
                }
              prec.quantita += parseInt(value.quantita)
              result[chiave] = prec
              return result
            }, {})
          } else if (infoImport.tipoFile === 'Terminale Online') {
            datiReduce = _.reduce(datiRaw, function(result, value, key, collection) {
              let chiave = String(value._id).trim()
              let prec = result[chiave] || {
                  _id: String(value._id).trim(),
                  quantita: 0
                }
              prec.quantita += parseInt(value.quantita)
              result[chiave] = prec
              return result
            }, {})
          }
          const dati = Object.values(datiReduce)
          await magazzino.importaInventarioLetture(infoImport.nomeFile, infoImport.tipoFile, infoImport.settore, infoImport.data, infoImport.note, datiRaw, dati)
          this.isimportaLetture = false
          this.annullaSelezione()
          await this.$nextTick()
          this.onLoaded()
          this.triggerReload++
          this.triggerPulisci++
        }
      },
      async importaLettureArray(infoImport) {
        const totaleDati = infoImport.totaleDati
         if (totaleDati > 0) {
          this.isimportaLetture = true
          const datiRaw = infoImport.datiRaw
          const datiReduce = _.reduce(datiRaw, function(result, value, key, collection) {
            let chiave = String(value.barcode).trim()
            let prec = result[chiave] || { barcode: chiave, quantita: 0 }
            prec.quantita += parseInt(value.quantita)
            result[chiave] = prec
            return result
          }, {})
          const dati = Object.values(datiReduce)
          await magazzino.importaInventarioLetture(infoImport.nomeFile, infoImport.tipoFile, infoImport.settore, infoImport.data, infoImport.note, datiRaw, dati)
          this.isimportaLetture = false
          this.annullaSelezione()
          await this.$nextTick()
          this.onLoaded()
          this.triggerReload++
          this.triggerPulisci++
        }
      },      
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
